import { Box } from '@components/Box'
import { TimeRangeEnum } from '@interfaces/TimeRangeEnum'
import { ReportSummaryDetail } from './components/ReportSummaryDetail'
import { SalesReportSearchForm } from './components/SalesReportSearchForm'
import { PurchaseProportion } from './components/PurchaseProportion'
import { MoneySpenderTable } from './components/MoneySpenderTable'
import { TopBookTable } from './components/TopBookTable'
import { TopWriterTable } from './components/TopWriterTable'
import { TopCharacterTable } from './components/TopCharacterTable'
import { SalesReportPageProps } from './interface'

export function SalesReportPage({
  data,
  searchParam,
  handleSubmit,
  handleExport,
  handleReset,
}: SalesReportPageProps) {
  return (
    <>
      <div className='w-full h-[1px] mt-[30px] mb-[20px] bg-gray' />
      <SalesReportSearchForm
        initialValues={{
          timeRange: TimeRangeEnum.MONTH,
          startAt: undefined,
          endAt: undefined,
        }}
        handleSubmit={handleSubmit}
        handleExport={handleExport}
        handleReset={handleReset}
      />
      <Box>
        {searchParam.startAt && searchParam.endAt ? (
          <>
            <ReportSummaryDetail searchParam={searchParam} />
            <PurchaseProportion searchParam={searchParam} />
            <MoneySpenderTable searchParam={searchParam} />
            <TopBookTable searchParam={searchParam} />
            <TopWriterTable searchParam={searchParam} />
            <TopCharacterTable searchParam={searchParam} />
          </>
        ) : (
          <div className='flex'>
            <div className='flex flex-col items-center justify-center w-full text-secondary-100'>
              <p className='text-[24px] px-[93px] mb-[8px] font-mitr text-secondary-50 flex justify-center font-medium'>
                เลือกช่วงเวลาแล้วกดค้นหาเพื่อดูข้อมูล
              </p>
            </div>
          </div>
        )}
      </Box>
    </>
  )
}
